<template>
  <f-box 
    class="stat p-7 has-row-3 has-no-col-gap has-no-row-gap" 
    grid
  >
    <p class="is-col-8 color-gray">
      <b>
        <small>
          <slot name="title"></slot>
        </small>
      </b>
    </p>

    <p 
      class="is-col-4 is-align-right color-placeholder"
    >
      <b>
        <small>
          <slot name="period"></slot>
        </small>
      </b>
    </p>

    <div 
      :class="[
        `m-0`, 
        {
          'is-col-6': displayChart || displayEvolution,
          'is-col-12': !displayChart && !displayEvolution,
        }
      ]"
    >
      <h6 class="color-blue-dark">
        <slot name="amount"></slot>
      </h6>
    </div>

    <div 
      v-if="displayChart" 
      class="stat-ingoings-chart is-col-6 is-row-2"
    >
      <div class="chart-container" ref="chartContainer"></div>
    </div>

    <div 
      v-if="displayEvolution" 
      class="stat-ingoings-percentage is-col-6 is-row-2"
    >
      <h5
        :class="[
          'm-0',
          {
            'color-success': dataEvolution.increase,
            'color-warning': dataEvolution.decrease,
          }
        ]"
      >{{ dataEvolution.percent }}</h5>

      <p v-if="month && dataEvolution.applicable">
        <small>Par rapport à {{ dataEvolution.month }}</small>
      </p>
    </div>
  </f-box>
</template>

<script>
import { onMounted, nextTick, ref, onUnmounted, computed, watch, toRefs, reactive } from 'vue'
import useStatistics from '@composables/statistics/use-statistics.js'
import useSparkChart from '@composables/statistics/charts/use-spark-chart.js'
import useNumbers from '@composables/use-numbers'

export default {
  props: {
    year: {
      type: [Number, null],
      default: null,
    },

    month: {
      type: [Number, null],
      default: null,
    },

    from: {
      type: [Date, null],
      default: null,
    },

    to: {
      type: [Date, null],
      default: null,
    },

    dataByMonth: {
      type: Array,
      default: () => []
    },

    dataEvolution: {
      type: Object,
      default: () => {}
    },

    displayEvolution: {
      type: Boolean,
      default: false,
    },

    displayChart: {
      type: Boolean,
      default: false,
    },
  },

  setup (props) {
    const { chartContainer } = useSparkChart(props)

    return {
      chartContainer,
      ...useNumbers(),
    }
  }
}
</script>

<style lang="scss">
.stat {
  position: relative;

  h6,
  p {
    margin: 0;
  }
}

.stat-ingoings-chart {
  position: relative;
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.chart-container {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
}

.stat-detail {
  border: none;
  box-shadow: 0 1px 1px 0 rgba(102, 166, 255, 0.1);
  background: $white;
  color: $blue-dark;
  padding: 0.1rem 0.3rem;
}
</style>
